var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBubbleSmile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 125,
    viewBox: "0 0 147 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.022 35.0709C83.3932 27.0081 65.9423 6.78585 51.464 21.7449C35.0904 38.6624 37.5608 68.7081 49.0138 88.1257C59.4132 105.757 81.2558 111.282 101.022 105.766C120.629 100.294 137.521 84.3718 138.187 63.1723C138.75 45.2296 116.22 42.0222 101.022 35.0709Z",
    fill: "#F1F4E7",
    stroke: "#FFBF08"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.3002 26.8048C67.0413 17.9962 47.976 -4.09669 32.1585 12.2462C14.2703 30.7285 16.9692 63.5536 29.4816 84.7673C40.8431 104.03 64.7061 110.065 86.3002 104.039C107.721 98.0611 126.176 80.6663 126.903 57.5057C127.519 37.9032 102.905 34.3992 86.3002 26.8048Z",
    stroke: "#FFBF08",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3779_14813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.2735 41.4418C52.321 43.9471 52.321 46.4525 52.2735 48.9578C52.2735 49.2893 52.34 49.4745 52.6444 49.6304C52.9772 49.8059 53.4908 49.8157 53.8522 49.7572C54.3277 49.6889 54.8317 49.5525 55.2406 49.2698C55.4879 49.104 55.9349 48.8116 55.9349 48.4704C55.9919 45.7896 55.9919 43.099 55.9349 40.4182C55.9349 40.1257 55.4118 39.9405 55.2216 39.9015C54.7937 39.804 54.2611 39.8625 53.8522 39.9795C53.1769 40.1842 52.2449 40.5839 52.264 41.4223L52.2735 41.4418Z",
    fill: "#FFB154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0577 40.683L62.9531 48.0528C62.9531 48.3842 63.0197 48.5695 63.324 48.7254C63.6569 48.9009 64.1704 48.9107 64.5318 48.8522C65.0073 48.7839 65.5114 48.6474 65.9203 48.3647C66.158 48.199 66.6145 47.9066 66.6145 47.5654L66.7191 40.1956C66.7191 39.8641 66.6526 39.6789 66.3482 39.5229C66.0154 39.3474 65.5018 39.3377 65.1405 39.3962C64.6649 39.4644 64.1609 39.6009 63.752 39.8836C63.5142 40.0493 63.0577 40.3418 63.0577 40.683Z",
    fill: "#FFB154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1714 63.4451C42.1927 69.3429 49.468 72.6281 56.9905 73.369C64.513 74.1099 72.8534 71.8288 79.5676 67.6564C83.4192 65.2583 86.8333 62.2265 89.81 58.7659C90.4567 58.0055 89.2584 57.5765 88.7163 57.5571C87.7368 57.5083 86.7097 57.9275 86.063 58.6781C81.5837 63.9033 75.716 68.1146 69.154 70.0448C62.592 71.975 55.9729 71.4583 49.9245 68.6995C46.4342 67.1105 43.3434 64.8099 40.8233 61.8659C39.9293 60.8228 36.1538 62.2655 37.1619 63.4451H37.1714Z",
    fill: "#FFB154"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3779_14813"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 34.139,
    fill: "white",
    transform: "translate(37 39.3757)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbleSmile);
export default __webpack_public_path__ + "static/media/bubble-smile.7526bf9dbcbd6a85d5fdba4b86a68767.svg";
export { ForwardRef as ReactComponent };